import { Link } from 'react-router-dom'

import { Button, Card, CryptoIcon } from '../../components'
import { PlatformStats } from '../../components/platform-stats'
import { Paths } from '../../config/routes'
import { PoolsTable } from './pools-table'

export function ConnectedInvestorDashboard() {
    const dataClasses = 'not-italic font-light text-sm leading-3 py-4'
    const enfasisClasses = ' text-black '

    return (
        <div
            className='grid gird-cols-6 gap-4 py-4 h-full'
            style={{ gridTemplateRows: '300px 300px 1fr' }}>
            <div className='row-span-1 col-span-4 xl:col-span-3'>
                <Card className=' w-full  h-full'>
                    <h3>🌽 Masa Automated Lending Pools</h3>
                    <PoolsTable
                        items={
                            <>
                                <tr
                                    className='border-b border-gray border-solid border-opacity-10 group'
                                    data-test-id={`transaction-item`}>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex flex-row justify-center w-full p-1'>
                                            <CryptoIcon name='USDC' />
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex truncate flex-row justify-center'>
                                            Masa USDC A Pool
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p className='text-black font-normal'>
                                                $134,608
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p>
                                                <span className='text-black font-normal'>
                                                    35%
                                                </span>{' '}
                                                locked
                                            </p>
                                            <p>
                                                <span className='text-black font-normal'>
                                                    65%
                                                </span>{' '}
                                                liquid
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p>Weekly</p>
                                            <p>APY</p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p className='text-black font-normal'>
                                                0.20%
                                            </p>
                                            <p className='text-black  font-normal'>
                                                15.54%
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words flex-row items-start justify-center h-full'>
                                            <Link to={Paths.LENDING_POOL}>
                                                <Button
                                                    className='border-black border'
                                                    minimal>
                                                    Pool
                                                </Button>
                                            </Link>
                                        </div>
                                    </td>
                                </tr>
                                <tr
                                    className='border-b border-gray border-solid border-opacity-10 group'
                                    data-test-id={`transaction-item`}>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex flex-row justify-center '>
                                            <CryptoIcon name='USDC' />
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex truncate flex-row justify-center'>
                                            Masa NFT USDC Pool
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p className='text-black font-normal'>
                                                $134,608
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p>
                                                <span className='text-black font-normal'>
                                                    50%
                                                </span>{' '}
                                                locked
                                            </p>
                                            <p>
                                                <span className='text-black font-normal'>
                                                    50%
                                                </span>{' '}
                                                liquid
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p>Weekly</p>
                                            <p>APY</p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p className='text-black font-normal'>
                                                0.20%
                                            </p>
                                            <p className='text-black  font-normal'>
                                                15.54%
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words flex-row items-start justify-center h-full'>
                                            <p className='text-black font-semibold'>
                                                Coming soon
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                            </>
                        }
                    />
                </Card>
            </div>
            <div className='row-span-1 col-span-4 xl:col-span-3'>
                <Card className='w-full h-full'>
                    <h3>🌽 Masa LP Token Farming</h3>
                    <PoolsTable
                        headers={[
                            'Asset',
                            'Pool Name',
                            'LP Tokens Pooled',
                            'Pooled Value',
                            'Interest Period',
                            'Rates',
                        ]}
                        items={
                            <>
                                {' '}
                                <tr
                                    className='border-b border-gray border-solid border-opacity-10 group'
                                    data-test-id={`transaction-item`}>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex flex-row justify-center w-full p-1'>
                                            <CryptoIcon name='USDC' />
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex truncate flex-row justify-center'>
                                            Masa USDC A Pool LP Farm
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p className='text-black font-normal'>
                                                $234,608
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p className='text-black font-normal'>
                                                $96,189,28
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p>Weekly</p>
                                            <p>APY</p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p className='text-black font-normal'>
                                                0.20%
                                            </p>
                                            <p className='text-black  font-normal'>
                                                10.4%
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words flex-row items-start justify-center h-full'>
                                            <div className='flex break-words flex-row items-start justify-center h-full'>
                                                <p className='text-black font-semibold'>
                                                    Coming soon
                                                </p>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr
                                    className='border-b border-gray border-solid border-opacity-10 group'
                                    data-test-id={`transaction-item`}>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex flex-row justify-center '>
                                            <CryptoIcon name='USDC' />
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex truncate flex-row justify-center'>
                                            Masa NFT USDC LP Farm
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p className='text-black font-normal'>
                                                $234,608
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p className='text-black font-normal'>
                                                $96,189,28
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p>Weekly</p>
                                            <p>APY</p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p className='text-black font-normal'>
                                                0.20%
                                            </p>
                                            <p className='text-black  font-normal'>
                                                10.4%
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words flex-row items-start justify-center h-full'>
                                            <p className='text-black font-semibold'>
                                                Coming soon
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                            </>
                        }
                    />
                </Card>
            </div>
            <div className='row-span-1 col-span-4 xl:row-span-2 xl:col-start-4 xl:row-start-1 xl:col-span-1 '>
                <Card>
                    <PlatformStats />
                </Card>
            </div>
        </div>
    )
}
